import { COLOR_PALETTES, LOGIN, LOGOUT, RESET_REDUX_STATE, SET_COMPANY_LOGO, SET_COMPANY_ICON } from "../constants";
import moment from "moment";
import { ApiCall } from "../../utils/index";

export const login = (payload, cb) => async (dispatch) => {
  try {
    const result = await ApiCall.post("/auth/login", payload);
    if (result.data) {
      const user = {
        ...result.data,
        expire: moment().add(1, "day"),
      };

      dispatch({ type: LOGIN, payload: user });
      dispatch({ type: RESET_REDUX_STATE });
      if(result?.data?.company?.color_palette) {
        const colorPalettes = JSON.parse((result?.data?.company?.color_palette))
        dispatch({ type: COLOR_PALETTES, payload: colorPalettes });
      }

      if(result?.data?.company?.logo) {
        dispatch({type: SET_COMPANY_LOGO, payload: result?.data?.company?.logo})
      }

      if(result?.data?.company?.icon) {
        dispatch({ type: SET_COMPANY_ICON, payload: result?.data?.company?.icon });
      }

      cb(result);
    }
  } catch (error) {
    cb(error);
    dispatch({ type: LOGOUT });
  }
};

export const signup = (payload, cb) => async () => {
  try {
    const result = await ApiCall.post("/company", payload);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const companyVerification = (payload, cb) => async () => {
  try {
    const result = await ApiCall.post(
      "/registrationVerification/verify",
      payload
    );
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const resendVerificationCode = (payload, cb) => async () => {
  try {
    const result = await ApiCall.post("/registrationVerification", payload);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const resetPasswordMail = (payload, cb) => async () => {
  try {
    const result = await ApiCall.post(
      "/passwordReset/send-verification",
      payload
    );
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const verifyResetPasswordVerificationCode =
  (payload, cb) => async () => {
    try {
      const result = await ApiCall.post("/passwordReset/verify", payload);
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const resetPassword = (payload, cb) => async () => {
  try {
    const result = await ApiCall.post(
      "/passwordReset/change-password",
      payload
    );
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const passwordChange = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { id, token },
    } = getState();
    const result = await ApiCall.put(`/user/updatepassword`, payload, token);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const userCheckVerificationCode =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const result = await ApiCall.post(
        `/user/check_verification_code`,
        payload
      );
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const userVerification = (payload, cb) => async (dispatch, getState) => {
  try {
    const result = await ApiCall.post(`/user/user_verification`, payload);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const optVerification = (request) => async (dispatch, getState) => {
  try {
    const result = await ApiCall.post(`/auth/request_otp`, request.payload);
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const checkVisibilitySubscription =
  (company_id, cb) => async (dispatch, getState) => {
    try {
      const result = await ApiCall.post("/company/check_visibility", {
        company_id: company_id,
      });
      cb(result.data);
    } catch (error) {
      // cb(error)
    }
  };

export const addRowsPerPage = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(
      `/user/row_count/${request.payload}`,
      token
    );
  } catch (error) {}
};

export const signUrlVerification =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const result = await ApiCall.get(`/auth/verify/${payload}`);

      if (result.data) {
        const user = {
          ...result.data,
          expire: moment().add(1, "day"),
        };
        if(!result.data.booking_id) localStorage.setItem("user", JSON.stringify(user));
        dispatch({ type: LOGIN, payload: user });
        dispatch({ type: RESET_REDUX_STATE });
        if(result?.data?.company?.color_palette) {
          const colorPalettes = JSON.parse((result?.data?.company?.color_palette))
          dispatch({ type: COLOR_PALETTES, payload: colorPalettes });
        }
  
        if(result?.data?.company?.logo) {
          dispatch({type: SET_COMPANY_LOGO, payload: result?.data?.company?.logo})
        }
  
        if(result?.data?.company?.icon) {
          dispatch({ type: SET_COMPANY_ICON, payload: result?.data?.company?.icon });
        }
        cb(result);
      }

      cb(result);
    } catch (error) {
      cb(error);
    }
  };
